import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

type BadgeTone = "neutral" | "info" | "success" | "warning" | "danger" | "primary";

const toneClasses: Record<BadgeTone, string> = {
  neutral: "bg-[#f1f5f9] text-[#475569]",
  info: "bg-[#e6f1fb] text-[#1d4ed8]",
  primary: "bg-[#2563eb] text-white",
  success: "bg-[#f0fdf4] text-[#065f46]",
  warning: "bg-[#fffbeb] text-[#92400e]",
  danger: "bg-[#fef2f2] text-[#991b1b]",
};

interface BadgeProps {
  tone?: BadgeTone;
  children: ReactNode;
  className?: string;
}

export function Badge({ tone = "neutral", children, className }: BadgeProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 rounded-[6px] px-2 py-0.5 text-[11px] font-semibold uppercase tracking-wide",
        toneClasses[tone],
        className,
      )}
    >
      {children}
    </span>
  );
}
